// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"672":"d97aeb00","808":"c82e7206","868":"f5eb677b","937":"9382349c"}[chunkId] + ".chunk.css";
};